import Icon from '@ant-design/icons'

const SVG = () => (
    <svg
        t='1738716380962'
        class='icon'
        viewBox='0 0 1024 1024'
        version='1.1'
        xmlns='http://www.w3.org/2000/svg'
        p-id='7687'
        width='200'
        height='200'
    >
        <path d='M333.871628 145.931907v219.826605h-59.534884v-219.802791z' fill='currentColor' p-id='7688'></path>
        <path
            d='M389.572465 250.522791v59.534883h-219.802791v-59.534883zM808.17414 637.809116l42.079255 42.10307-146.527255 146.527256-42.10307-42.079256zM344.111628 637.809116l42.079256 42.10307-146.55107 146.527256-42.079256-42.079256z'
            fill='currentColor'
            p-id='7689'
        ></path>
        <path
            d='M239.639814 637.809116l146.55107 146.55107-42.10307 42.079256-146.527256-146.527256zM878.068093 250.522791v59.534883H658.217674v-59.534883z'
            fill='currentColor'
            p-id='7690'
        ></path>
        <path
            d='M881.54493 18.479628H141.859721A124.261209 124.261209 0 0 0 17.860465 142.45507v739.685209a124.261209 124.261209 0 0 0 123.999256 123.999256h739.661395a124.261209 124.261209 0 0 0 123.999256-123.999256V142.478884A124.261209 124.261209 0 0 0 881.54493 18.455814z m-739.685209 59.534884h739.661395a64.726326 64.726326 0 0 1 64.464372 64.440558v739.685209a64.726326 64.726326 0 0 1-64.440558 64.464372H141.859721a64.726326 64.726326 0 0 1-64.464372-64.464372V142.478884a64.726326 64.726326 0 0 1 64.464372-64.464372z'
            fill='currentColor'
            p-id='7691'
        ></path>
        <path d='M975.75293 470.325581v59.534884H145.336558v-59.534884z' fill='currentColor' p-id='7692'></path>
        <path d='M975.75293 470.325581v59.534884H145.336558v-59.534884z' fill='currentColor' p-id='7693'></path>
        <path d='M553.674419 121.522605v830.416372h-59.534884V121.522605z' fill='currentColor' p-id='7694'></path>
    </svg>
)

export const CalculatorIcon = props => <Icon component={SVG} {...props} />
